package com.mencanhealth.admin.data

import com.mencanhealth.admin.model.AdminAuthState
import com.mencanhealth.admin.model.SubscriptionTier
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.first

class AdminAuthService {

    private val auth = Firebase.auth
    private val firestore = Firebase.firestore

    private val _state = MutableStateFlow(AdminAuthState(isLoading = true))
    val state: StateFlow<AdminAuthState> = _state.asStateFlow()

    suspend fun checkExistingSession() {
        _state.value = AdminAuthState(isLoading = true)
        try {
            // Wait for Firebase Auth to resolve the persisted session
            val user = auth.authStateChanged.first()
            if (user != null) {
                verifyAdmin(user.uid, user.email)
            } else {
                _state.value = AdminAuthState()
            }
        } catch (_: Exception) {
            _state.value = AdminAuthState()
        }
    }

    suspend fun signIn(email: String, password: String) {
        _state.value = _state.value.copy(isLoading = true, error = null)
        try {
            val result = auth.signInWithEmailAndPassword(email, password)
            val user = result.user ?: throw Exception("Sign-in failed")
            verifyAdmin(user.uid, user.email)
        } catch (e: Exception) {
            _state.value = AdminAuthState(error = e.message ?: "Sign-in failed")
        }
    }

    suspend fun signOut() {
        try { auth.signOut() } catch (_: Exception) {}
        _state.value = AdminAuthState()
    }

    private suspend fun verifyAdmin(uid: String, email: String?) {
        try {
            val doc = firestore.collection("users").document(uid).get()
            val tierStr = doc.get<String>("tier")
            val tier = try { SubscriptionTier.valueOf(tierStr) } catch (_: Exception) { SubscriptionTier.FREE }
            if (tier == SubscriptionTier.ADMIN) {
                _state.value = AdminAuthState(
                    isAuthenticated = true,
                    isAdmin = true,
                    email = email,
                    userId = uid
                )
            } else {
                auth.signOut()
                _state.value = AdminAuthState(error = "Access denied: ADMIN tier required")
            }
        } catch (e: Exception) {
            auth.signOut()
            _state.value = AdminAuthState(error = "Failed to verify permissions: ${e.message}")
        }
    }
}
